module.exports = __webpack_public_path__ + "img/2024-11-15a_3.9feac05d.jpg";